import { render, staticRenderFns } from "./PivotGrid.vue?vue&type=template&id=4ae6a116&scoped=true&"
import script from "./PivotGrid.vue?vue&type=script&lang=js&"
export * from "./PivotGrid.vue?vue&type=script&lang=js&"
import style0 from "./PivotGrid.vue?vue&type=style&index=0&id=4ae6a116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae6a116",
  null
  
)

export default component.exports